import React from "react";
import { BiDownload } from "react-icons/bi";
import { motion } from "framer-motion";

const Hero = () => {
  const parenElement = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 3,
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.4,
      },
    },
  };

  const children = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  };
  return (
    <motion.div
      variants={parenElement}
      initial="hidden"
      animate="visible"
      id="home"
      className="
      flex text-white z-0 justify-center items-center mx-auto  h-screen  bg-[#023047]	dark:bg-black  bg-cover"
    >
      <div className="flex flex-col gap-3  max-w-[75%] z-40 text-white">
        <h5 className="text-4xl ph:text-xl ">hey!</h5>

        <motion.h1
          variants={children}
          className="text-4xl ph:text-2xl lg:text-6xl font-bold"
        >
          I'm Fedi
        </motion.h1>
        <motion.p variants={children} className="ph:text-xs text-base">
          I'm a front-end developer,student
        </motion.p>
        <motion.p variants={children} className="ph:text-xs text-base">
          I like learning new technologies and sharing what I learn
        </motion.p>
        <motion.div
          variants={children}
          className="pt-8 flex gap-5 ph:gap-2 ph:text-xs text-lg"
        >
          <a
            href="mailto: fedirouatbi@gmail.com"
            className=" group relative overflow-hidden h-[48px]  ph:h-auto  cta z-10  hover:scale-105 flex justify-center items-center transition-all ease-in-out"
          >
            <button className="capitalize">contact me</button>
            <div className="absolute transition-transform duration-500 ease-in-out bg-sky-400/80 inset-0 origin-left scale-x-0 z-[-1]  group-hover:scale-x-100   "></div>
          </a>
          <motion.a
            download
            whileHover={{ backgroundColor: "#fff", color: "#000" }}
            className="cursor-pointer rounded-md  self-start px-5 py-2 ph:px-3   hover:scale-105 border-2  border-white  capitalize  flex items-center gap-3 transition-all ease-out "
            href="./Fedi Rouatbi, Front-end Developer.pdf"
          >
            resume
            <BiDownload />
          </motion.a>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Hero;
